module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/video-8027e.png";